import Vue from 'vue'
import Vuex from 'vuex'
import $common from '@/utils/common.js'
import common from './modules/common'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // httpUrl: "http://39.99.146.123:11000/portal-api",
	  // httpUrl: "http://127.0.0.1:8088/portal-api",
    httpUrl: "https://crmsrv.ccsi.com.cn/portal-api",
	  pageSize: 10,
      showTestFlag: false
  },
  mutations: {
	  // 重置vuex本地储存状态
	  // resetStore (state) {
	  //   Object.keys(state).forEach((key) => {
	  //     state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
	  //   })
	  // }
  },
  actions: {
  },
  modules: {
    common,
    user
  },
})
